
import ENVIRONMENT from "../../environment/environment";

export const API_BASE_URL = ENVIRONMENT.API_HOST;
export const BASE_URL = ENVIRONMENT.BASE_URL;

export const API_VERSION = 'v1';

type Environment = 'development' | 'staging' | 'production';

interface SignalRSetting {
    hubUrl: string;
    authEndpoint: string;
}

// Get current environment from NODE_ENV
export const getCurrentEnvironment = (): Environment => {
    const env = (process.env.NODE_ENV ||
        process.env.NEXT_PUBLIC_ENV ||
        'development') as string;

    if (env === 'production') return 'production';
    if (env === 'staging') return 'staging';
    return 'development';
};

// Dev: kết nối thẳng hub (tránh Next proxy /socket → 500 LongPolling)
const SIGNALR_HUB_URL =
    process.env.NODE_ENV === 'production'
        ? `${BASE_URL}/socket/chathub`
        : (process.env.NEXT_PUBLIC_SIGNALR_HUB_URL || `${BASE_URL}/socket/chathub`);

export const SIGNALR_CONFIG: Record<Environment, SignalRSetting> = {
    development: {
        hubUrl: SIGNALR_HUB_URL,
        authEndpoint: `${API_BASE_URL}/${API_VERSION}/auth/checkauth`
    },
    staging: {
        hubUrl: SIGNALR_HUB_URL,
        authEndpoint: `${API_BASE_URL}/${API_VERSION}/auth/checkauth`
    },
    production: {
        hubUrl: SIGNALR_HUB_URL,
        authEndpoint: `${API_BASE_URL}/${API_VERSION}/auth/checkauth`
    }
};

// Get SignalR config for current environment
export const getSignalRConfig = (): SignalRSetting => {
    const env = getCurrentEnvironment();
    return SIGNALR_CONFIG[env];
};